import { useLanguage } from '../../contexts/LanguageContext';
import { Share2 } from 'lucide-react';

export default function ShareButtons({ article }) {
  const { t } = useLanguage();
  // Use the visitor's actual origin (window.location.origin) so shared URLs
  // always match the domain they're on — never leaks the internal backend host
  // (e.g. emergent.host) into WhatsApp / Twitter previews.
  const articleId = article?.article_id;
  const articleSlug = article?.slug;
  const origin = typeof window !== 'undefined' ? window.location.origin : '';
  const shareUrl = (articleSlug || articleId)
    ? `${origin}/api/og/article/${articleSlug || articleId}`
    : (typeof window !== 'undefined' ? window.location.href : '');
  const title = encodeURIComponent(article?.title_kn || article?.title || '');
  const summary = encodeURIComponent(article?.summary_kn || article?.summary || '');
  const encodedUrl = encodeURIComponent(shareUrl);

  const shares = [
    { name: 'WhatsApp', letter: 'W', color: '#25D366', url: `https://wa.me/?text=${title}%20${encodedUrl}` },
    { name: 'Facebook', letter: 'f', color: '#1877F2', url: `https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}` },
    { name: 'Twitter', letter: 'X', color: '#000000', url: `https://twitter.com/intent/tweet?text=${title}&url=${encodedUrl}` },
    { name: 'LinkedIn', letter: 'in', color: '#0A66C2', url: `https://www.linkedin.com/sharing/share-offsite/?url=${encodedUrl}&title=${title}&summary=${summary}` },
    { name: 'Telegram', letter: 'T', color: '#229ED9', url: `https://t.me/share/url?url=${encodedUrl}&text=${title}` },
  ];

  return (
    <div className="flex items-center gap-2" data-testid="share-buttons">
      <span className="flex items-center gap-1.5 text-xs text-muted-foreground">
        <Share2 className="w-3.5 h-3.5" />{t('share')}
      </span>
      {shares.map(s => (
        <a key={s.name} href={s.url} target="_blank" rel="noopener noreferrer"
          className="w-7 h-7 rounded-full flex items-center justify-center text-white text-[10px] font-bold transition-all duration-300 hover:scale-110 hover:shadow-lg magnetic-btn"
          style={{ backgroundColor: s.color }}
          data-testid={`share-${s.name.toLowerCase()}`}>
          {s.letter}
        </a>
      ))}
    </div>
  );
}
